import { EMPTY_OBJECT } from '../../../lib/globals';
import { getTestProps } from '../../../lib/helpers';

interface LogModalHeadersProps {
  /**
   * Response Headers
   */
  headers?: { [key: string]: string | string[] };
  /**
   * Test id
   */
  testId?: string;
}

const LogModalHeaders = ({
  headers = EMPTY_OBJECT,
  testId = '',
}: LogModalHeadersProps) => {
  if (headers && Object.entries(headers).length > 0) {
    const res = [];
    for (const [key, value] of Object.entries(headers)) {
      res.push(
        <div
          key={key}
          className="mb-1"
          {...getTestProps(testId, `item-${key}`)}
        >
          <span className="text-base">{key}</span>
          <span className="mr-2">:</span>
          <span className="text-base">{value}</span>
        </div>,
      );
    }
    return res;
  }
};

export default LogModalHeaders;
